import { ConsumptionType } from '@colven/common-domain-lib/lib'
import i18n from '@/i18n'
import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";

export default {
    name: 'FuelTabComponent',
    components: {
        AutocompleteComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: true,
        consumptionTypes: [
            {
                value: null,
                text: i18n.t('equipment.editDialog.fuel.consumptionType.NO_TYPE'),
                custom: false
            },
            {
                value: ConsumptionType.KM,
                text: i18n.t('equipment.editDialog.fuel.consumptionType.KM'),
                custom: false
            },
            {
                value: ConsumptionType.KM_RPM,
                text: i18n.t('equipment.editDialog.fuel.consumptionType.KM_RPM'),
                custom: false
            },
            {
                value: ConsumptionType.KM_SPEED,
                text: i18n.t('equipment.editDialog.fuel.consumptionType.KM_SPEED'),
                custom: false
            },
            {
                value: ConsumptionType.HS,
                text: i18n.t('equipment.editDialog.fuel.consumptionType.HS'),
                custom: false
            },
            {
                value: ConsumptionType.HS_SPEED,
                text: i18n.t('equipment.editDialog.fuel.consumptionType.HS_SPEED'),
                custom: false
            },
        ],
        showRange: false,
        showLiters: false,
        rangeFromPlaceholder: null,
        rangeToPlaceholder: null
    }),
    computed: {
    },
    created() {
        this.validateFields()
    },
    beforeDestroy() {
    },
    mounted() {
    },
    methods: {
        validateFields() {
                if (this.model.consumption.type) {
                    if (this.model.consumption.type != ConsumptionType.KM && this.model.consumption.type != ConsumptionType.HS) {
                        this.showRange = true
                        this.showLiters = true
                        // seteo el placeholder para los inputs de rango
                        switch (this.model.consumption.type) {
                            case ConsumptionType.KM_RPM:
                                this.rangeFromPlaceholder = i18n.t('equipment.editDialog.fuel.consumptionRange.KM_RPM.from');
                                this.rangeToPlaceholder = i18n.t('equipment.editDialog.fuel.consumptionRange.KM_RPM.to');
                                break;
                            case ConsumptionType.KM_SPEED:
                                this.rangeFromPlaceholder = i18n.t('equipment.editDialog.fuel.consumptionRange.KM_SPEED.from');
                                this.rangeToPlaceholder = i18n.t('equipment.editDialog.fuel.consumptionRange.KM_SPEED.to');
                                break;
                            case ConsumptionType.HS_SPEED:
                                this.rangeFromPlaceholder = i18n.t('equipment.editDialog.fuel.consumptionRange.HS_SPEED.from');
                                this.rangeToPlaceholder = i18n.t('equipment.editDialog.fuel.consumptionRange.HS_SPEED.to');
                                break;
                        }
                    }
                    else {
                        this.showRange = false
                        this.showLiters = true
                    }
                }
                else {
                    this.showLiters = false
                    this.showRange = false
                    this.model.consumption.litres = null
                    this.model.consumption.pricePerLitre = null
                    this.model.consumption.to = null
                    this.model.consumption.from = null
                }
        },
        fuelTypeConsumptionSelected(newValue) {
            this.model.consumption.type = typeof newValue.value !== 'undefined' ? newValue.value :  this.model.consumption.type
            this.validateFields()
        }
    },
    watch: {
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.fuelDataTabForm) {
                this.$refs.fuelDataTabForm.resetValidation()
            }
        },
        isValidForm(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit('update:validForm', newVal)
            }
        },
        'model.consumption.type': {
            deep: true,
            handler: function () {
                this.validateFields()
            }
        }
    }
}
